module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dtitems-wrapper"
  }, [_c('div', {
    staticClass: "dtitems-header"
  }, [_c('navbar', {
    attrs: {
      "title": "供货商对账单-明细-品项"
    }
  }), _vm._v(" "), _c('w-search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "placeholder": "可搜索品项名称",
      "showFilterBtn": false
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dtitems-div"
  }, [_c('div', {
    staticClass: "dtitems-th"
  }, [_c('div', {
    staticClass: "dtitems-th-col dtitems-th-col-name"
  }, [_vm._v("品项名称")]), _vm._v(" "), _c('div', {
    staticClass: "dtitems-th-col dtitems-th-col-amount"
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "dtitems-th-col dtitems-th-col-unit"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "dtitems-th-col dtitems-th-col-money"
  }, [_vm._v("含税金额")])]), _vm._v(" "), _c('div', {
    staticClass: "dtitems-content"
  }, _vm._l((_vm.itemListCalc), function(item, index) {
    return _c('div', {
      staticClass: "dtitems-td"
    }, [_c('div', {
      staticClass: "dtitems-td-col dtitems-th-col-name"
    }, [_vm._v(_vm._s(item.item_name))]), _vm._v(" "), _c('div', {
      staticClass: "dtitems-td-col dtitems-td-col-amount"
    }, [_vm._v(_vm._s(item.instore_sum_amount))]), _vm._v(" "), _c('div', {
      staticClass: "dtitems-td-col dtitems-th-col-unit"
    }, [_vm._v(_vm._s(item.unit))]), _vm._v(" "), _c('div', {
      staticClass: "dtitems-td-col dtitems-td-col-money"
    }, [_vm._v(_vm._s(item.include_tax_sum_money))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dtitems-div-bottom",
    on: {
      "click": _vm.onDtitemClick
    }
  }, [_c('button', {
    staticClass: "dtitems-bottom-btn"
  }, [_vm._v("返回")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-200e93a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierAccountCheckDetailBillDt.vue
// module id = 545
// module chunks = 1